var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"text-detail"},[_c('div',{staticClass:"text-content"},[_c('div',{class:[this.isPay == 1 ? 'hiddCon' : '', 'conBox'],domProps:{"innerHTML":_vm._s(_vm.article.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }